export const CTA_GRADIENT = "linear-gradient(180deg, #0F6E56 0%, #046A38 100%)";
export const CTA_SHADOW = "0 10px 24px -6px rgba(4,106,56,0.45), 0 2px 4px rgba(0,0,0,0.06)";
export const CARD_SHADOW = "0 2px 8px -2px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)";
export const SUMMARY_SHADOW = "0 4px 16px -4px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)";
export const STEPPER_ACTIVE_GRADIENT = "linear-gradient(180deg, #0F6E56, #046A38)";
export const STEPPER_ACTIVE_SHADOW = "0 4px 12px -2px rgba(4,106,56,0.4)";
